import { queryOptions } from "@tanstack/react-query";
import { api } from "@/shared/api/client";
import {
  DocumentListResponse,
  DocumentReadResponse,
  type DocumentListItem,
  type DocumentReadResponse as DocRead,
  MyCatalog,
} from "@/shared/api/schemas";
import { z } from "zod";

export const myCatalogsQuery = queryOptions({
  queryKey: ["catalogs", "mine"],
  queryFn: async () => {
    const raw = await api<unknown>("/v1/me/catalogs");
    return z.array(MyCatalog).parse(raw);
  },
});

export function documentsQuery(catalog: string) {
  return queryOptions({
    queryKey: ["catalogs", catalog, "documents"],
    queryFn: async (): Promise<DocumentListItem[]> => {
      const raw = await api<unknown>(
        `/v1/catalogs/${encodeURIComponent(catalog)}/documents?limit=1000`,
      );
      const parsed = DocumentListResponse.parse(raw);
      return parsed.data;
    },
  });
}

export function documentQuery(catalog: string, slug: string) {
  return queryOptions({
    queryKey: ["catalogs", catalog, "doc", slug],
    queryFn: async (): Promise<DocRead> => {
      const raw = await api<unknown>(
        `/v1/catalogs/${encodeURIComponent(catalog)}/documents/${slug
          .split("/")
          .map(encodeURIComponent)
          .join("/")}?limit=2000&maxBytes=262144`,
      );
      return DocumentReadResponse.parse(raw);
    },
  });
}
